import { BackgroundJobStatus } from "@bvhi/backend-api";
import { Chip } from "@bvhi/ui-base";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  status: string;
  size?: "small" | "medium";
}

export function BackgroundJobStatusChip({ status, size = "small" }: Props) {
  const { t } = useTranslation(["enums"]);

  const label = useMemo(() => {
    if (status === BackgroundJobStatus.OPEN) return t("enums:enums.background.job.status.open");
    if (status === BackgroundJobStatus.ENQUEUED) return t("enums:enums.background.job.status.enqueued");
    if (status === BackgroundJobStatus.SCHEDULED) return t("enums:enums.background.job.status.scheduled");
    if (status === BackgroundJobStatus.PROCESSING) return t("enums:enums.background.job.status.processing");
    if (status === BackgroundJobStatus.FINISHED) return t("enums:enums.background.job.status.finished");
    if (status === BackgroundJobStatus.FAILED) return t("enums:enums.background.job.status.failed");

    return "";
  }, [status, t]);

  const color = useMemo(() => {
    if (status === BackgroundJobStatus.FAILED) return "error";
    if ([BackgroundJobStatus.ENQUEUED.toString(), BackgroundJobStatus.SCHEDULED.toString()].includes(status)) return "info";
    return "success";
  }, [status]);

  return <Chip color={color} label={label} size={size} />;
}
